export default __webpack_public_path__ + "static/media/ruby-logo-navy.f3382070.svg";